import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { UserProvider } from "../contexts/UserContext";
import { useAuth } from "../contexts/AuthContext";

const LoadingOverlay: React.FC = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      style={{
        width: "5rem",
        height: "5rem",
        border: "0.6rem solid #e0f7fa",
        borderTop: "0.6rem solid #00b1c5",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
    />
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

const ProtectedRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === null) {
    return <LoadingOverlay />; // 初期チェック中（ただしこの例では常にbooleanになるので不要になるかも）
  }

  return isAuthenticated ? (
    <UserProvider>
      <Outlet />
    </UserProvider>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutes;
